import EventEmitter from "events";
import { t } from "i18next";

const toastEmitter = new EventEmitter();

type ToastType = "success" | "error" | "info";

// Helper to check if a string is a valid ToastType
const isToastType = (val: string): val is ToastType =>
  ["success", "error", "info"].includes(val);

export const showToast = (
  message: string,
  infoOrType?: string,
  defaultType: ToastType = "success"
) => {
  let type: ToastType = defaultType;
  let info: string | undefined;

  if (infoOrType && isToastType(infoOrType)) {
    type = infoOrType;
  } else if (infoOrType) {
    info = infoOrType;
  }

  toastEmitter.emit("showToast", {
    message: t(message),
    info: info ? t(info) : undefined,
    type,
  });
};

export const onToast = (
  callback: (data: { message: string; info?: string; type: ToastType }) => void
) => {
  toastEmitter.on("showToast", callback);
};

export const offToast = () => {
  toastEmitter.removeAllListeners("showToast");
};
